import React, { useState, useEffect, useContext } from "react";
import { useTheme } from "@emotion/react";

import Keypad from "../../components/Keypad";
import { Context as PinContext, STORAGE_KEY_STORED_PIN } from "../../utils/pin";
import { useStorage } from "../../utils/storage";
import { FurnitureContext } from "../../utils/furniture";

import { SafeAreaProvider } from "react-native-safe-area-context";
import { Container, Logo, Caption } from "./styles";
import ErrorBlock from "../../components/ErrorBlock";
import {
    MyPlanLogo,
    MyPlanLogoDark,
    MyPlanLogoLight,
} from "myplan/components/Logo";

const PinUnlock = ({ navigation, props }) => {
    const [, setActivePin] = useContext(PinContext);
    const {
        strings: { pinUnlockCaption, pinEntryError },
    } = useContext(FurnitureContext);
    const [storedPin] = useStorage(STORAGE_KEY_STORED_PIN);
    const [pin, setPin] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    const theme: any = useTheme();

    const resetPin = () => {
        setTimeout(() => {
            setPin("");
            setIsDisabled(false);
        }, 1000);
    };

    useEffect(() => {
        if (pin) {
            if (pin.length >= 4) {
                setIsDisabled(true);

                if (pin === storedPin) {
                    setActivePin(pin);
                } else if (pin === "0000") {
                    resetPin();
                    return navigation.navigate("Safe Mode");
                } else {
                    setErrorMessage(pinEntryError);
                    resetPin();
                }
            } else if (pin.length) {
                setErrorMessage("");
            }
        }
    }, [pin]);

    return (
        <SafeAreaProvider>
            <Container>
                <Logo>
                    <MyPlanLogo width="392" height="65" />
                </Logo>
                <Caption>{pinUnlockCaption}</Caption>
                <ErrorBlock message={errorMessage} />
                <Keypad onChange={setPin} value={pin} isDisabled={isDisabled} />
            </Container>
        </SafeAreaProvider>
    );
};

export default PinUnlock;
